// extracted by mini-css-extract-plugin
module.exports = {"input":"Input_input__7tYkx","error":"Input_error__juFPf","readOnly":"Input_readOnly__2zXW7","skeleton":"Input_skeleton__Kbpvj"};